import { Power2, Power4 } from 'gsap'
import { Time } from '../util/Time'

export class SkillBlock {
  constructor() {
    this.els = [...document.querySelectorAll('.js-skill-block')].map((el) => {
      const [head, body] = [...el.children]
      return {
        el,
        head,
        body,
      }
    })
    this.el = this.els[0].el.parentElement
    this.time = new Time()
    this.time.on('update', this.update.bind(this))
  }
  update() {
    this.el.style.setProperty('--hypot', Math.hypot(window.innerWidth, window.innerHeight))
    this.els.forEach(({ el, head, body }, i) => {
      const rect = el.getBoundingClientRect()
      const p = Math.max(0, Math.min(1, (-rect.top + window.innerHeight * (i === 0 ? -0.25 : 0.5)) / (head.offsetHeight - window.innerHeight)))

      const p1 = Math.max(0, Math.min(1, p * 2))
      const p2 = Math.max(0, Math.min(1, p * 2 - 1))
      if (i === 0) {
        const heading = head.querySelector('.sticky__heading')
        if (heading) {
          const headingRect = heading.getBoundingClientRect()
          const headingCenter = headingRect.top + headingRect.height / 2
          const viewCenter = window.innerHeight / 2
          const pHeading = Math.max(0, Math.min(1, 1 - (headingCenter - viewCenter) / (window.innerHeight * 0.5)))
          el.style.setProperty('--p-heading', Power4.easeInOut(pHeading))
        }
      }

      el.style.setProperty('--p', p)
      el.style.setProperty('--p1', Power4.easeInOut(p1))
      el.style.setProperty('--p2', Power4.easeInOut(p2))
    })
  }
}
